import videojs from 'video.js';
import objectFitVideos from 'object-fit-videos';

// скролл до блоков
$('body').on('click', '.js-article-infobar-link', (e) => {
	$('html, body').animate({
		scrollTop: $(`#${$.attr(e.currentTarget, 'data-target')}`).position().top,
	}, 500);
});

let $video = $('#videoJs');

// запуск видео
if ($video[0]) {
	let player = videojs($video.get(0), {
		controls: true,
		fluid: true,
		// poster: $video.attr('poster'),
	});

	player.on('ready', () => {
		player.pause(true);
	});

	objectFitVideos();
}
